import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAnalytics } from 'firebase/analytics';
import { getAuth, signInWithCustomToken } from 'firebase/auth';

// Your web app's Firebase configuration
// TODO: Replace this configuration with the one from your Firebase Console
// To get this:
// 1. Go to Firebase Console (https://console.firebase.google.com/)
// 2. Select your project
// 3. Click the web icon (</>)
// 4. Register the app if you haven't
// 5. Copy the firebaseConfig object
const firebaseConfig = {
  apiKey: "AIzaSyDjgUcj5WPln9OWOB51Ikp2FkQE_QspNRQ",
  authDomain: "beyond-roast-landing.firebaseapp.com",
  databaseURL: "https://beyond-roast-landing-default-rtdb.firebaseio.com", // Added default RTDB URL
  projectId: "beyond-roast-landing",
  storageBucket: "beyond-roast-landing.firebasestorage.app",
  messagingSenderId: "706519584332",
  appId: "1:706519584332:web:fd29b5bce276de3f722ee9",
  measurementId: "G-03HNKPZ1K3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics
const analytics = getAnalytics(app);

// Initialize Realtime Database
const database = getDatabase(app);

// Initialize Authentication
const auth = getAuth(app);

// Function to sign in as admin
export const signInAsAdmin = async (token) => {
  try {
    await signInWithCustomToken(auth, token);
    return true;
  } catch (error) {
    console.error('Error signing in as admin:', error);
    return false;
  }
};

export { database, analytics, auth }; 